import { useContext } from "react";
import { AuthContext } from "../contexts/auth-context";

export const useIsAuthenticated = () => {
    // Null will not be the case because it marks loading state.
    return useContext(AuthContext).isAuthenticated!;
};
